import type { IconName } from '../types';

export const iconPaths: Record<IconName, string> = {
  'angle-left': '/assets/icons/angle-left.svg',
  'angle-right': '/assets/icons/angle-right.svg',
  'arrow-back': '/assets/icons/arrow-back.svg',
  'arrow-left': '/assets/icons/arrow-left.svg',
  'arrow-right-to-bracket': '/assets/icons/arrow-right-to-bracket.svg',
  'arrow-up-outline': '/assets/icons/arrow-up-outline.svg',
  'bell-outline': '/assets/icons/bell-outline.svg',
  'calendar-month': '/assets/icons/calendar-month.svg',
  'cash-outline': '/assets/icons/cash-outline.svg',
  check: '/assets/icons/check.svg',
  'check-circle': '/assets/icons/check-circle.svg',
  'chevron-down': '/assets/icons/chevron-down.svg',
  'chevron-right': '/assets/icons/chevron-right.svg',
  'chevron-sort': '/assets/icons/chevron-sort.svg',
  'clipboard-list-outline': '/assets/icons/clipboard-list-outline.svg',
  'clock-outline': '/assets/icons/clock-outline.svg',
  'cog-outline': '/assets/icons/cog-outline.svg',
  'copy-outline': '/assets/icons/copy-outline.svg',
  'dots-horizontal-outline': '/assets/icons/dots-horizontal-outline.svg',
  'download-outline': '/assets/icons/download-outline.svg',
  'edit-outline': '/assets/icons/edit-outline.svg',
  exclamation: '/assets/icons/exclamation.svg',
  eye: '/assets/icons/eye.svg',
  'eye-slash-outline': '/assets/icons/eye-slash-outline.svg',
  factory: '/assets/icons/factory.svg',
  file: '/assets/icons/file.svg',
  'file-image': '/assets/icons/file-image.svg',
  'file-lines-outline': '/assets/icons/file-lines-outline.svg',
  'freepik-arrows-inject-2': '/assets/icons/freepik-arrows-inject-2.svg',
  'freepik-background-simple-inject-2': '/assets/icons/freepik-background-simple-inject-2.svg',
  'freepik-background-simple-inject-2-1': '/assets/icons/freepik-background-simple-inject-2-1.svg',
  'freepik-contract-inject-2': '/assets/icons/freepik-contract-inject-2.svg',
  'freepik-device-1-inject-2': '/assets/icons/freepik-device-1-inject-2.svg',
  'freepik-device-2-inject-2': '/assets/icons/freepik-device-2-inject-2.svg',
  'freepik-graphics-inject-2': '/assets/icons/freepik-graphics-inject-2.svg',
  'freepik-graphics-inject-2-1': '/assets/icons/freepik-graphics-inject-2-1.svg',
  'freepik-left-hand-inject-2': '/assets/icons/freepik-left-hand-inject-2.svg',
  'freepik-plants-inject-2': '/assets/icons/freepik-plants-inject-2.svg',
  'freepik-right-hand-inject-2': '/assets/icons/freepik-right-hand-inject-2.svg',
  'home-outline': '/assets/icons/home-outline.svg',
  'info-outline': '/assets/icons/info-outline.svg',
  'lock-outline': '/assets/icons/lock-outline.svg',
  'message-dots-outline': '/assets/icons/message-dots-outline.svg',
  'plus-outline': '/assets/icons/plus-outline.svg',
  'question-mark-outline': '/assets/icons/question-mark-outline.svg',
  'ruble-sign': '/assets/icons/ruble-sign.svg',
  'search-outline': '/assets/icons/search-outline.svg',
  'unlock-outline': '/assets/icons/unlock-outline.svg',
  'upload-outline': '/assets/icons/upload-outline.svg',
  'user-circle-outline': '/assets/icons/user-circle-outline.svg',
  'x-outline': '/assets/icons/x-outline.svg',
  zip: '/assets/icons/zip.svg',
};
